import { useState, type CSSProperties, type FormEvent } from 'react';
import simbolo from '@libreta/ui/marca/simbolo.svg';
import { Boton, Campo, Entrada } from '../componentes/Controles';
import { Icono } from '../componentes/Icono';
import { mensajeDeError } from '../componentes/Piezas';
import { esElegirEntidad, useSesion } from '../sesion/sesion';

export function PaginaIngreso() {
  const sesion = useSesion();
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [entidades, setEntidades] = useState<Array<{ id: string; nombre: string; rol: string }> | null>(null);

  async function ingresar(evento?: FormEvent, entidadId?: string) {
    evento?.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await sesion.ingresar(usuario, clave, entidadId);
    } catch (e) {
      if (esElegirEntidad(e)) setEntidades(e.detalles.entidades);
      else setError(mensajeDeError(e));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="ingreso">
      <section className="ingreso__arte" aria-hidden>
        <div className="ingreso__marca">
          <img src={simbolo} alt="" />
          <strong>Libreta</strong>
        </div>
        <div className="ingreso__lema">
          <h1>Cada cuota, en su renglón.</h1>
          <p>Ventas en cuotas, stock, cobranzas y recibos. Lo que vence, lo que se cobró y lo que falta, de un vistazo.</p>
        </div>
        <div className="ingreso__tarjetas">
          {[
            { tono: 'pagado', titulo: 'Cuota 4 de 12', detalle: 'Pagada hoy · recibo R-000431' },
            { tono: 'por-vencer', titulo: 'Vence el viernes', detalle: 'Gs. 345.000' },
            { tono: 'vencido', titulo: '12 días de atraso', detalle: 'Mora al día calculada' },
          ].map((tarjeta, i) => (
            <div key={tarjeta.titulo} className="ingreso__tarjeta" style={{ '--i': i } as CSSProperties}>
              <span className={`ingreso__punto ingreso__punto--${tarjeta.tono}`} />
              <div>
                <strong>{tarjeta.titulo}</strong>
                <small>{tarjeta.detalle}</small>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ingreso__formulario">
        {entidades ? (
          <div className="ingreso__caja">
            <div>
              <h2>¿Dónde entrás?</h2>
              <p>Tu usuario trabaja en más de una entidad.</p>
            </div>
            <div className="ingreso__entidades">
              {entidades.map((entidad) => (
                <button key={entidad.id} type="button" className="ingreso__entidad" onClick={() => void ingresar(undefined, entidad.id)} disabled={enviando}>
                  <Icono nombre="caja" />
                  <div>
                    <strong>{entidad.nombre}</strong>
                    <small>{entidad.rol}</small>
                  </div>
                  <Icono nombre="derecha" />
                </button>
              ))}
            </div>
            <Boton variante="fantasma" icono="izquierda" onClick={() => setEntidades(null)}>Volver</Boton>
          </div>
        ) : (
          <form className="ingreso__caja" onSubmit={(e) => void ingresar(e)}>
            <div>
              <h2>Ingresar</h2>
              <p>Con tu usuario, correo o número de cédula, y tu contraseña.</p>
            </div>
            <div className="formulario">
              <Campo etiqueta="Usuario, correo o cédula">
                {(id) => <Entrada id={id} type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} value={usuario} onChange={(e) => setUsuario(e.target.value)} autoFocus required />}
              </Campo>
              <Campo etiqueta="Contraseña">
                {(id) => <Entrada id={id} type="password" autoComplete="current-password" value={clave} onChange={(e) => setClave(e.target.value)} required />}
              </Campo>
            </div>
            {error ? <p className="nota nota--error" role="alert"><Icono nombre="alerta" />{error}</p> : null}
            <Boton type="submit" variante="primario" tamano="grande" cargando={enviando} icono="derecha">Entrar</Boton>
          </form>
        )}
      </section>
    </div>
  );
}
